import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1, textAlign: 'end' }}>
                <LinearProgress
                    variant="determinate" {...props}
                    sx={{
                        backgroundColor: "var(--light-primary-color)",
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: "var(--light-color-graph)",
                        }
                    }}
                />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}